import React, { useEffect, useState } from "react";
import { AppLayout } from "../../../layouts";
import { Cards, Header, NavAndTabs, Sides } from "../../../components";
import { Col, Container, Row } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { actionDoctor, actionPatient } from "../../../redux/actions";
import MyFinances from "./myFinances";
import ClinicFinances from "./clinicFinances";
import { useTranslation } from "react-i18next";



const Finances = ({ loginData }) => {
    const { t } = useTranslation();
    const options1 = [
        { value: 1, label: t("OnLine") },
        { value: 2, label: t("InClinic") },
        { value: 3, label: t("Chat") },
        { value: 4, label: t("Emergency") },
    ];
    const dispatch = useDispatch();
    const [credentials, setCredentials] = useState({
        CurrencyCode: loginData?.currencyCode,
        IsOwn: true,
        clinicGuid: loginData.clinicGuid,
        doctorGuid: loginData.userGuid,
    });
    const [activeTab, setActiveTab] = useState("my-finances");
    const [clinicFees, setClinicFees] = useState(false);
    const onTabChange = (tabId) => {
        setActiveTab(tabId);

        const clinicFees = tabId === "clinics-finances";
        setClinicFees(clinicFees);
    };

    useEffect(() => {
        dispatch(actionDoctor.postFinanceData(credentials));
        dispatch(actionDoctor.getClinicDoctor(loginData.userGuid));
        dispatch(actionDoctor.getClinicDoctorDetails(loginData.clinicGuid));
    }, [dispatch, credentials, loginData]);

    // pageSize, currentPage, search, sortExp, sortDir, patientGuid, doctorGuid, appointmentStatuses, fromDate, toDate, isRequiredRefundData, IsRequiredCommissionData, UserCurrency, UserTimeZone, clinicGuid, isOwn, isAnother, LanguageId, appointmentTypes,
    useEffect(() => {
        dispatch(actionPatient.getAppointments(10, 1, "", "", "", "", loginData.userGuid, null, "", "", true, true, loginData?.currencyCode, loginData.timeZoneId, null, true, false, loginData?.languageId, null, null))
    }, [dispatch, loginData]);


    const postFinanceData = useSelector(
        (state) => state.doctor.postFinanceData?.data
    );
    const getClinicDoctorData = useSelector(
        (state) => state.doctor.getClinicDoctorData?.data
    );
    const getClinicDoctorDetailsData = useSelector(
        (state) => state.doctor.getClinicDoctorDetailsData?.data
    );
    const getAppointmentsData = useSelector(
        (state) => state.patient.getAppointmentsData?.data
    );

    const financeData = [
        {
            header: t("doctor.myFinance.total_earning"),
            title: `${credentials.CurrencyCode}   ${postFinanceData?.result?.totalEarning || 0
                }`,
            content: "",
        },
        {
            header: t("doctor.myFinance.Total_Offline_Earning"),
            title: `${credentials.CurrencyCode}   ${postFinanceData?.result?.totalOfflineEarning || 0
                }`,
            content: "",
        },
        {
            header: t("doctor.myFinance.Total_Online_Earning"),
            title: `${credentials.CurrencyCode}   ${postFinanceData?.result?.totalOnlineEarning || 0
                }`,
            content: "",
        },
        {
            header: t("doctor.myFinance.Total_Refunded"),
            title: `${credentials.CurrencyCode}   ${postFinanceData?.result?.totalRefunded || 0
                }`,
            content: "",
        },
        {
            header: t("doctor.myFinance.Total_Pending"),
            title: `${credentials.CurrencyCode}   ${postFinanceData?.result?.totalPending || 0
                }`,
            content: "",
        },
    ];

    const tabs = [
        {
            id: "my-finances",
            label: `${t("My")} ${t("Finances")}`,
            content: (
                <MyFinances
                    getClinicDoctorData={getClinicDoctorData}
                    getClinicDoctorDetailsData={getClinicDoctorDetailsData}
                    getAppointmentsData={getAppointmentsData}
                    options1={options1}
                    loginData={loginData}
                />
            ),
            disabled: false,
        },
        {
            id: "clinics-finances",
            label: `${t("Clinics")} ${t("Finances")}`,
            content: <ClinicFinances />,
            disabled: false,
        },
    ];

    const rightSide = (
        <Container fluid className="exado-container1">
            <Row className="exado-row1">
                <Col>
                    <Header.HeadingPage pageHeading={`${t("My")} ${t("Finances")}`} />
                </Col>
            </Row>
            <Row className="exado-row1">
                {financeData?.map((item, index) => (
                    <Col key={index} lg={3} md={4} className="exado-col">
                        <Cards.Cardd
                            className="cardd"
                            header={item.header}
                            title={item.title}
                            content={item.content}
                        />
                    </Col>
                ))}
            </Row>
            <Row className="exado-row1">
                <Col>
                    <NavAndTabs.NavAndTabs
                        tabs={tabs}
                        activeTab={activeTab}
                        onTabChange={onTabChange}
                    />
                </Col>
            </Row>
        </Container>
    );
    return (
        <AppLayout.AppLayoutOne
            leftSide={<Sides.LeftSides loginData={loginData} />}
            rightSide={rightSide}
        />
    );
};

export default Finances;
